import React from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAnchor } from "@fortawesome/free-solid-svg-icons";
import "../styles/Footer.css";

const FOOTER_COLUMNS = [
  {
    heading: "Discover",
    links: [
      { label: "Deals", to: "/business-listings" },
      { label: "Treasure Map", to: "/pirate-map" },
      { label: "Events", to: "/events" },
      { label: "Real Estate", to: "/properties" },
      { label: "Featured Businesses", to: "/business-listings?promoted=1" },
    ],
  },
  {
    heading: "Travelers",
    links: [
      { label: "How It Works", to: "/how-it-works" },
      { label: "Traveler Passes", to: "/traveler-passes" },
      { label: "Doubloons", to: "/doubloons" },
      { label: "Roommate Finder", to: "/roommate-finder" },
    ],
  },
  {
    heading: "Businesses",
    links: [
      { label: "For Businesses", to: "/for-businesses" },
      { label: "List Your Business", to: "/signup?audience=business" },
      { label: "Business Dashboard", to: "/business-dashboard" },
      { label: "Staff Sign-In", to: "/staff/login" },
    ],
  },
  {
    heading: "Guild",
    links: [
      { label: "Contact", to: "/contact" },
      { label: "Help & Support", to: "/support" },
      { label: "Account", to: "/account" },
      { label: "Privacy Policy", to: "/privacy" },
      { label: "Terms of Service", to: "/terms" },
      { label: "Cookie Policy", to: "/cookies" },
      { label: "Do Not Sell or Share", to: "/account/privacy" },
    ],
  },
];

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-columns">
        {FOOTER_COLUMNS.map((col) => (
          <div key={col.heading} className="footer-column">
            <h4 className="footer-column__heading">{col.heading}</h4>
            <ul className="footer-column__links">
              {col.links.map((link) => (
                <li key={link.to + link.label}>
                  <Link to={link.to}>{link.label}</Link>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
      <div className="footer-content">
        <FontAwesomeIcon icon={faAnchor} className="footer-icon" />
        <p>
          USVI Pirate's Guild &copy; {new Date().getFullYear()} | Powered by
          Pangaea Hospitality
        </p>
        <p className="footer-tagline">
          Travel perks, local discovery, and business promotion across the U.S.
          Virgin Islands.
        </p>
      </div>
    </footer>
  );
}

export default Footer;
